import { Component, Signal, computed, model, signal } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';

import { IRecommendationsEntry } from 'src/app/_models/recommendations.model';
import { RecommendationRowComponent } from '../recommendation-row/recommendation-row.component';

@Component({
    selector: 'kbm-recommendation-list',
    standalone: true,
    imports: [
        MatFormFieldModule,
        MatIconModule,
        MatButtonModule,
        MatChipsModule,
        RecommendationRowComponent,
    ],
    templateUrl: './recommendation-list.component.html',
    styleUrls: ['./recommendation-list.component.scss']
})
export class RecommendationListComponent {
  recommendations = model.required<IRecommendationsEntry[] | null>();
  newRecommendation = signal<IRecommendationsEntry>({"from": "", "to": ""});

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;

  onDelete(row: number) {
    this.recommendations.update(recommendations => {
      recommendations!.splice(row, 1);
      return recommendations;
    })
  }

  addRecommendation(evt: any) {
    this.recommendations.update((recommendations) => {
      this.recommendations()?.push(evt);
      return recommendations;
    })

  }

}
